/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/FreeCellLogic/IDailyFreeCellAuthority',[
    'SolitaireShared/FreeCellLogic/FreeCellAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/CardOp',
    'SolitaireShared/CardLogic/MoveState'
], function (FreeCellAuthority, IDailyAuthority, CardOp, MoveState) {
    "use strict";

    var IDailyFreeCellAuthority = function () {
        this.initIDailyFreeCellAuthority();
    };

    IDailyFreeCellAuthority.constructor = IDailyFreeCellAuthority;
    IDailyFreeCellAuthority.prototype = Object.create(FreeCellAuthority.prototype);
    IDailyAuthority.call(IDailyFreeCellAuthority.prototype);

    IDailyFreeCellAuthority.prototype.initIDailyFreeCellAuthority = function () {
        FreeCellAuthority.call(this);

        this.MovesAllowed = 0;

        this._startingTime = 0;

        this.ChallengeType = IDailyAuthority.ChallengeType.Unknown;

        this.DeckSeeds = [];

        this.IsChallenge = true;

        this.TotalMoves = 0;
    };

    Object.defineProperty(IDailyFreeCellAuthority.prototype, "TimerEnabled", {
        get: function () {
            return this._startingTime != 0;
        }
    });


    Object.defineProperty(IDailyFreeCellAuthority.prototype, "StartingTime", {
        get: function () {
            return this._startingTime;
        },
        set: function (value) {
            this._startingTime = value;
            this.CardSupply.IsTimerCountdown = this._startingTime != 0;
        }
    });


    IDailyFreeCellAuthority.prototype.GetStartingTime = function () {
        return this._startingTime;
    };


    var TagMoveperformed = 0x40000000;


    IDailyFreeCellAuthority.prototype.GetScoreForAction = function (action) {
        for (var i = 0; i < action.Ops.length; i++) {
            var op = action.Ops[i];
            if (this.MovesAllowed > 0 && action.GetActionUndoCount() == 0 && op.Opcode != CardOp.Op.Noop && op.Opcode != CardOp.Op.Deal) {
                action.Tag = (action.Tag | TagMoveperformed) >>> 0;
            }
        }

        return FreeCellAuthority.prototype.GetScoreForAction.call(this, action);
    };


    IDailyFreeCellAuthority.prototype.OnRunSpecialAction = function (tag, undo) {
        if (this.MovesAllowed > 0)
            this.TotalMoves += (undo ? -1 : 1);

        FreeCellAuthority.prototype.OnRunSpecialAction.call(this, tag, undo);
    };

    IDailyFreeCellAuthority.prototype.IsGameWon = function () {
        if (this.MovesAllowed > 0)
            return (this.CheckWin() && this.TotalMoves <= this.MovesAllowed + 1);

        return this.CheckWin();
    };

    IDailyFreeCellAuthority.prototype.CheckWin = function () {
        if (this.GetCompletedStacks() == 4)
            return true;

        return false;
    };

    IDailyFreeCellAuthority.prototype.CurrentMoveState = function () {
        if (this.MovesAllowed > 0)
        {
            if (this.TotalMoves > this.MovesAllowed + 1)
            {
                return MoveState.NoMovesLeft;
            }
            if (this.TotalMoves == this.MovesAllowed + 1)
            {
                if (this.IsGameWon())
                {
                    return MoveState.CanMove;
                }
                return MoveState.NoMovesLeft;
            }
        }
        return FreeCellAuthority.prototype.CurrentMoveState.call(this);
    };


//#if !CHEATS
    IDailyFreeCellAuthority.prototype.GetHint = function (cycle, cheat) {
        cycle = !!cycle;
        if(!cheat) {
            return new CardOp(this.CardSupply);
        } else {
            return FreeCellAuthority.prototype.GetHint.call(this, cycle, cheat);
        }
    };

//#endif
    IDailyFreeCellAuthority.prototype.Deal = function () {
        this.TotalMoves = 0;

        if (this.DeckSeeds.length > 0)
            this.CardSupply.DeckSeed = this.DeckSeeds[0];

        return FreeCellAuthority.prototype.Deal.call(this);
    };

    IDailyFreeCellAuthority.prototype.SetDealScript = function (script) {
        this.DealScript = script;
    };

    IDailyFreeCellAuthority.prototype.SetNumBoardsCompleted = function (numBoards) {
    };

    return IDailyFreeCellAuthority;


});
